// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/Test/components/testView.scss
// module id = 1253
// module chunks = 0